import React, { useEffect, useState } from "react";
import "./JewelPage.css";
import feature1 from "../images/feature1.png";
import feature2 from "../images/feature2.png";
import feature3 from "../images/feature3.png";
import jewellogo1 from "../images/jewellogo1.png";
import jewellogo2 from "../images/jewellogo2.png";
import jewellogo3 from "../images/jewellogo3.png";
import jewellogo4 from "../images/jewellogo4.png";
import jewellogo5 from "../images/jewellogo5.png";
import jewellogo6 from "../images/jewellogo6.png";

import laptop from "../images/laptop.png";
import bgImage from "../images/jewelhome.png";
import bgImage2 from "../images/jewelhome3.png";
import bgImageenterprice from "../images/bgImageenterprice.png";
import bgImageprofit from "../images/bgImageprofit.png";
import bgimagelovedby from "../images/bgimagelovedby.png";
import demojewel from "../images/demo-jewellery.jpg";
import freeweb from "../images/demojewelfreeweb.jpeg";

import BASE_URL from '../apiConfig';
import useRecaptcha from "../hooks/useRecaptcha";

import { FiTrendingUp, FiBox, FiDollarSign, FiZap } from "react-icons/fi";

function JewelPage() {

  const [popupMessage, setPopupMessage] = useState("");
  const [popupWidgetId, setPopupWidgetId] = useState(null);
  const [mainWidgetId, setMainWidgetId] = useState(null);
  const [play, setPlay] = useState(false);


  // ✅ EXTRA STATES
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const { getResponse } = useRecaptcha();

  // ✅ FULL INDIA STATES
  const indiaStates = [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
    "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
    "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
    "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
    "Uttar Pradesh", "Uttarakhand", "West Bengal",
    "Delhi", "Jammu & Kashmir", "Ladakh", "Chandigarh", "Puducherry"
  ];

  // Sample city mapping (expand later if needed)
  const stateCities = {
    Kerala: ["Kochi", "Trivandrum", "Kozhikode", "Thrissur"],
    Karnataka: ["Bangalore", "Mysore", "Mangalore"],
    TamilNadu: ["Chennai", "Coimbatore", "Madurai"],
    Maharashtra: ["Mumbai", "Pune", "Nagpur"],
    Delhi: ["New Delhi"]
  };

  // ✅ STATE


  // ✅ STATE
  const [showPopup, setShowPopup] = useState(false);

  const [formData, setFormData] = useState({
    full_name: "",
    phone: "",
    email: "",
    state: "",
    city: "",
    shop_name: "",
    challenges: ""
  });


  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "state") {
      setFormData({
        ...formData,
        state: value,
        city: ""
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };
  const handleSubmit = async (e, type = "main") => {
    e.preventDefault();

    if (!formData.full_name || !formData.phone) {
      const msg = "❌ Name, Phone are required.";
      type === "popup" ? setPopupMessage(msg) : setMessage(msg);
      return;
    }

    setLoading(true);

    try {
      const token = type === "popup" ? getResponse(popupWidgetId) : getResponse(mainWidgetId);
      if (!token) {
        const errorMsg = "❌ Please complete the reCAPTCHA.";
        type === "popup" ? setPopupMessage(errorMsg) : setMessage(errorMsg);
        setLoading(false);
        return;
      }
      const fd = new FormData();

      Object.keys(formData).forEach(key => {
        fd.append(key, formData[key]);
      });

      fd.append("_type", "jewel_demo");
      fd.append("tk", token);

      const response = await fetch(
        BASE_URL + "/DemoApi/saveData",
        {
          method: "POST",
          body: fd
        }
      );

      const result = await response.json();

      if (result.status) {
        type === "popup"
          ? setPopupMessage("✅ Demo Request Submitted")
          : setMessage("✅ Demo Request Submitted");

        setFormData({
          full_name: "",
          phone: "",
          email: "",
          state: "",
          city: "",
          shop_name: "",
          challenges: ""
        });
      } else {
        const msg = "❌ " + (result.message || "Verification Failed");
        type === "popup" ? setPopupMessage(msg) : setMessage(msg);
      }

    } catch (err) {
      console.error("Submission Error:", err);
      const msg = "❌ Submission Failed. Check Console.";
      type === "popup" ? setPopupMessage(msg) : setMessage(msg);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (window.grecaptcha) {
      // Main form rendering
      const mainContainer = document.getElementById("recaptcha-main-jewel");
      if (mainContainer && mainContainer.innerHTML === "") {
        try {
          const id = window.grecaptcha.render(mainContainer, {
            // sitekey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
             sitekey: window.RECAPTCHA_SITE_KEY,
          });
          setMainWidgetId(id);
        } catch (err) {
          console.error("reCAPTCHA main render error:", err);
        }
      }

      // Popup form rendering
      if (showPopup) {
        const timer = setTimeout(() => {
          const popupContainer = document.getElementById("recaptcha-popup-jewel");
          if (popupContainer && popupContainer.innerHTML === "") {
            try {
              const id = window.grecaptcha.render(popupContainer, {
                // sitekey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
                 sitekey: window.RECAPTCHA_SITE_KEY,
              });
              setPopupWidgetId(id);
            } catch (err) {
              console.error("reCAPTCHA popup render error:", err);
            }
          }
        }, 500);
        return () => clearTimeout(timer);
      }
    }
  }, [showPopup]);

  // ✅ SCROLL DETECTION
  useEffect(() => {
    const handleScroll = () => {
      const statsSection = document.querySelector(".stats-section-jewel");
      if (!statsSection) return;

      const rect = statsSection.getBoundingClientRect();

      if (rect.top <= window.innerHeight * 0.7) {
        setShowPopup(true);
        window.removeEventListener("scroll", handleScroll);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  useEffect(() => {
    const carousel = document.getElementById("miniCarousel");
    const prevBtn = document.getElementById("prevBtn");
    const nextBtn = document.getElementById("nextBtn");

    const cards = carousel.children;
    const totalCards = cards.length;

    let index = 0;

    function updateCarousel() {
      const cardWidth = carousel.children[0].offsetWidth;
      carousel.style.transform = `translateX(-${index * cardWidth}px)`;
    }

    nextBtn.onclick = () => {
      if (index < totalCards - 4) {
        index++;
        updateCarousel();
      }
    };

    prevBtn.onclick = () => {
      if (index > 0) {
        index--;
        updateCarousel();
      }
    };

  }, []);







  return (
    <>



      {/* HERO SECTION */}
      {/* <div className="Jewel-wrapper"> */}
      <div
        className="Jewel-wrapper"
        style={{
          backgroundImage: `url(${bgImage2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat"
        }}
      >

        <div className="Jewel-left">
          <h1>IGNOSI – HALLMARK</h1>

          <h2 className="Jewel-subtitle">
            Complete Jewellery Business Software Designed Exclusively for Jewellers
          </h2>

          <h3 className="Jewel-tagline">
            Manage accounts, stock, sales, and customer records seamlessly — all from a single platform.
          </h3>

          <p>
            Ignosi Hallmark is a complete solution for jewellery businesses,
            covering purchase management, inventory tracking, sales billing,
            and customer relationship management in one unified system.
          </p>

          <ul>
            <li>Online Jewellery Management</li>
            <li>Mobile App for Directors</li>
            <li>GST-Compliant Billing</li>
          </ul>
        </div>

        <div className="Jewel-right">
          <form className="demo-form-jewel" onSubmit={handleSubmit}>

            <input
              type="text"
              name="full_name"
              placeholder="Full Name *"
              value={formData.full_name}
              onChange={handleChange}
              required
            />

            <input
              type="tel"
              name="phone"
              placeholder="Phone Number *"
              value={formData.phone}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
            />

            {/* STATE DROPDOWN */}
            {/* <select
              name="state"
              value={formData.state}
              onChange={handleChange}
            >
              <option value="">-- Select State --</option>
              {indiaStates.map((state) => (
                <option key={state} value={state}>{state}</option>
              ))}
            </select> */}

            {/* CITY DROPDOWN */}
            {/* <select
              name="city"
              value={formData.city}
              onChange={handleChange}
              disabled={!formData.state}
            >
              <option value="">-- Select City --</option>
              {stateCities[formData.state]?.map((city) => (
                <option key={city} value={city}>{city}</option>
              ))}
            </select> */}

            <input
              type="text"
              name="shop_name"
              placeholder="Jewellery Name(optional)"
              value={formData.shop_name}
              onChange={handleChange}
            />

            <textarea
              name="challenges"
              placeholder="What challenges are you looking to solve?"
              value={formData.challenges}
              onChange={handleChange}
            />

            {/* <div className="captcha-container" style={{ margin: "10px 0", textAlign: "left" }}>
              <label style={{ color: "#333", fontSize: "14px" }}>{initData.captcha_q || "Loading verification..."}</label>
              <input
                type="text"
                name="captcha_ans"
                placeholder="Enter Answer *"
                value={formData.captcha_ans}
                onChange={handleChange}
                required
                style={{ marginTop: "5px" }}
              />
            </div> */}

            <div
              id="recaptcha-main-jewel"
              style={{ marginBottom: "15px" }}
            ></div>

            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Book a Demo"}
            </button>

            {message && (
              <p className="form-message-jewel">
                {message}
              </p>
            )}

          </form>
        </div>
      </div>








      {/* CARD 1 */}
      <section className="testimonial-section">

        <div className="testimonial-container">

          {/* LEFT CONTENT */}
          <div className="testimonial-left">
            <h2>
              From the Makers of <span>Trusted Banking Software</span>
            </h2>

            <p>
              Built with years of financial technology expertise, our jewellery ERP
              delivers unmatched accuracy, profit clarity, and business intelligence.
            </p>
          </div>

          {/* RIGHT VIDEO */}
          <div
            className="video-wrapper"
            onClick={(e) => {
              const wrapper = e.currentTarget;
              wrapper.innerHTML = `
          <iframe 
            src="https://www.youtube.com/embed/5i4dbUTyOYQ?autoplay=1"
            title="Client Testimonial"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
          </iframe>
        `;
            }}
          >
            <img
              src="https://img.youtube.com/vi/5i4dbUTyOYQ/maxresdefault.jpg"
              alt="Client Testimonial"
            />
            <div className="play-button">▶</div>
          </div>
<div className="video-wrapper">
   <img src={freeweb} alt="Intelligent Purchase Management" />
</div>
        </div>

      </section>







      {/* FEATURES SECTION */}
      <div className="features-section-jewel">

        {/* CARD 1 */}
        <div className="feature-card-jewel">
          <div className="feature-image-jewel">
            <img src={feature2} alt="Intelligent Purchase Management" />
          </div>

          <div className="feature-bar-jewel">
            Intelligent Purchase Management
          </div>

          <div className="feature-hover-jewel">
            <ul>
              <li>Supplier & Karigar Management – Complete vendor database with payment terms</li>
              <li>Purchase Order Generation – Auto-calculated metal rates and making charges</li>
              <li>Raw Material Receipt – Weight verification and purity testing documentation</li>
              <li>Job Work Tracking – Send-out and receive-back with wastage calculations</li>
              <li>GST Compliant Invoicing – HSN codes, tax calculations, and e-invoicing</li>
              <li>Estimated Mobile App Billing</li>
              <li>Barcode Aging</li>
            </ul>
          </div>
        </div>


        {/* CARD 2 */}
        <div className="feature-card-jewel">
          <div className="feature-image-jewel">
            <img src={feature1} alt="Multi-Metal Inventory Management" />
          </div>

          <div className="feature-bar-jewel">
            Multi-Metal Inventory Management
          </div>

          <div className="feature-hover-jewel">
            <ul>
              <li>Gold, Silver, Diamond & Mixed Items – Purity-wise and category-wise tracking</li>
              <li>Item Master with 360° Details – Weight, purity, making charges, stones, hallmarks, images</li>
              <li>Barcode Integration – Unique tagging from purchase to sale</li>
              <li>Stock Categorization – Finished jewellery, raw materials, semi-finished, scrap</li>
              <li>Multiple Unit Support – Grams, Sovereigns, Tola, Bullion, 100 touch, Carats (Diamonds)</li>
            </ul>
          </div>
        </div>


        {/* CARD 3 */}
        <div className="feature-card-jewel">
          <div className="feature-image-jewel">
            <img src={feature3} alt="Smart Sales and POS System" />
          </div>

          <div className="feature-bar-jewel">
            Smart Sales & POS System
          </div>

          <div className="feature-hover-jewel">
            <ul>
              <li>Quick Billing – Retail, wholesale, and export invoices</li>
              <li>Automated Price Calculation – Live gold rate + making charge + GST</li>
              <li>Customer CRM Integration – Purchase history, preferences, anniversary tracking</li>
              <li>Exchange & Buyback Management – Accurate old jewellery valuation</li>
              <li>Sales Return & Exchange – Proper stock reconciliation</li>
            </ul>
          </div>
        </div>

      </div>





      {/* WHY IGNOSI SECTION */}
      <div className="why-ignosi-section-jewel">

        <h2 className="why-title-jewel">
          Why IGNOSI for Jewellery Traders?
        </h2>

        <p className="why-subtitle-jewel">
          Built exclusively for jewellers who want more than accounting —
          IGNOSI focuses on profitability, control, and long-term growth.
        </p>

        <div className="why-grid-jewel">

          <div className="why-card-jewel">
            <div className="why-icon-jewel">📊</div>
            <h3>Profit-First Intelligence</h3>
            <p>
              Not just accounting reports — IGNOSI helps you understand margins,
              identify profit leaks, and make data-driven decisions.
            </p>
          </div>

          <div className="why-card-jewel">
            <div className="why-icon-jewel">💎</div>
            <h3>Real-Time Stock Valuation</h3>
            <p>
              Know the exact worth of your business at any moment with live gold,
              silver, and diamond rate-based valuation.
            </p>
          </div>

          <div className="why-card-jewel">
            <div className="why-icon-jewel">🛡️</div>
            <h3>Margin Protection</h3>
            <p>
              Smart pricing rules and discount controls prevent accidental losses
              while empowering sales teams.
            </p>
          </div>

          <div className="why-card-jewel">
            <div className="why-icon-jewel">🏦</div>
            <h3>Gold Loan Integration</h3>
            <p>
              Convert idle inventory into working capital with structured gold loan
              tracking and valuation support.
            </p>
          </div>

          <div className="why-card-jewel">
            <div className="why-icon-jewel">🏬</div>
            <h3>Multi-Location Ready</h3>
            <p>
              Seamlessly manage multiple showrooms, branches, and warehouses from
              a single unified dashboard.
            </p>
          </div>

        </div>
      </div>
      {/* WHY IGNOSI SECTION ENDS*/}





      {/* STATS SECTION */}
      <div className="stats-section-jewel">

        <h1 className="stats-title-jewel">
          Trusted by Jewellery Businesses Across India
        </h1>

        <div className="stats-grid-jewel">

          <div className="stat-card-jewel">
            <div className="stat-icon-jewel">💎</div>
            <h3>100+</h3>
            <h3>Jewellery Stores Using Our Software</h3>
          </div>

          <div className="stat-card-jewel">
            <div className="stat-icon-jewel">📦</div>
            <h3>5M+</h3>
            <h3>Ornaments Managed Digitally</h3>
          </div>

          <div className="stat-card-jewel">
            <div className="stat-icon-jewel">💰</div>
            <h3>₹500Cr+</h3>
            <h3>Transactions Processed Monthly</h3>
          </div>

          <div className="stat-card-jewel">
            <div className="stat-icon-jewel">⚡</div>
            <h3>99.9%</h3>
            <h3>System Uptime & Reliability</h3>
          </div>

        </div>
      </div>






      {/* PROFIT INTELLIGENCE DASHBOARD */}

      {/* <div className="profit-section-jewel"> */}
      <div
        className="profit-section-jewel"
        style={{
          backgroundImage: `url(${bgImageprofit})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat"
        }}
      >

        <h2 className="profit-title-jewel">
          Profit Intelligence Dashboard
        </h2>

        <p className="profit-subtitle-jewel">
          Actionable insights that help jewellers maximize margins, optimize stock,
          and make smarter pricing decisions.
        </p>

        <div className="profit-grid-jewel">

          {/* COLUMN 1 */}
          <div className="profit-card-jewel">
            <h3>What Will Make You Profit?</h3>
            <ul>
              <li><strong>Margin Analysis by Category</strong> – Identify jewellery types with highest margins</li>
              <li><strong>Fast vs. Slow Moving Items</strong> – Spot best-sellers and dead stock instantly</li>
              <li><strong>Customer Profitability</strong> – High-profit customers vs discount-driven buyers</li>
              <li><strong>Staff Performance & Commission</strong> – Salesperson-wise profitability tracking</li>
              <li><strong>Promotion Effectiveness</strong> – Measure discount impact on net profit</li>
            </ul>
          </div>

          {/* COLUMN 2 */}
          <div className="profit-card-jewel">
            <h3>Market Value Impact on Your Stock</h3>
            <ul>
              <li><strong>Real-Time Stock Valuation</strong> – Live valuation using current metal rates</li>
              <li><strong>Historical Value Tracking</strong> – Understand market impact over time</li>
              <li><strong>Purchase vs Current Value</strong> – Unrealized profit & loss visibility</li>
              <li><strong>Rate Alert System</strong> – Notifications on major price movements</li>
            </ul>
          </div>

          {/* COLUMN 3 */}
          <div className="profit-card-jewel">
            <h3>Calculated Margin & Discount Guidance</h3>
            <ul>
              <li><strong>Dynamic Pricing Suggestions</strong> – Optimal price based on target margins</li>
              <li><strong>Discount Limiter</strong> – Prevent over-discounting with alerts</li>
              <li><strong>Seasonal Pricing Strategies</strong> – Festival-ready margin optimization</li>
              <li><strong>Competitor Price Benchmarking</strong> – Stay competitive without losing profit</li>
              <li><strong>Stock Aging Analysis</strong> – Smart discounting for slow-moving items</li>
            </ul>
          </div>

        </div>
      </div>

      {/* PROFIT INTELLIGENCE DASHBOARD END */}











      {/* PREMIUM COMPACT TESTIMONIALS */}
      {/* FULL WIDTH PREMIUM TESTIMONIALS */}
      {/* ================= FULL WIDTH TESTIMONIALS ================= */}

      <div className="full-testimonials-section">

        {/* <h2 className="full-title">Loved by Modern Jewellers</h2> */}

        <div className="full-carousel-wrapper">

          <button className="full-arrow left" id="prevBtn">
            ‹
          </button>

          <div className="full-carousel-viewport">
            <div className="full-carousel" id="miniCarousel">

              {/* CARD 2 */}
              <div className="full-card">
                <div className="full-card-inner">
                  <div className="stars">★★★★★</div>
                  <p>“Stock management is effortless now.”</p>
                  <h4>Mehta Diamonds</h4>
                </div>
              </div>

              {/* CARD 3 */}
              <div className="full-card">
                <div className="full-card-inner">
                  <div className="stars">★★★★★</div>
                  <p>“Multi-branch tracking is seamless.”</p>
                  <h4>Sri Lakshmi Jewellers</h4>
                </div>
              </div>

              {/* CARD 4 */}
              <div className="full-card">
                <div className="full-card-inner">
                  <div className="stars">★★★★★</div>
                  <p>“IGNOSI gives complete business control.”</p>
                  <h4>Golden Shine Jewellers</h4>
                </div>
              </div>

              {/* CARD 4 */}
              <div className="full-card">
                <div className="full-card-inner">
                  <div className="stars">★★★★★</div>
                  <p>“IGNOSI gives complete business control.”</p>
                  <h4>Golden Shine Jewellers</h4>
                </div>
              </div>

              {/* CARD 4 */}
              <div className="full-card">
                <div className="full-card-inner">
                  <div className="stars">★★★★★</div>
                  <p>“IGNOSI gives complete business control.”</p>
                  <h4>Golden Shine Jewellers</h4>
                </div>
              </div>

              {/* CARD 4 */}
              <div className="full-card">
                <div className="full-card-inner">
                  <div className="stars">★★★★★</div>
                  <p>“IGNOSI gives complete business control.”</p>
                  <h4>Golden Shine Jewellers</h4>
                </div>
              </div>

            </div>
          </div>

          <button className="full-arrow right" id="nextBtn">
            ›
          </button>

        </div>





        {/* LOGO STRIP */}
        <div className="logo-strip-full">

          <img src={jewellogo1} alt="client" />
          <img src={jewellogo2} alt="client" />
          <img src={jewellogo3} alt="client" />
          <img src={jewellogo4} alt="client" />
          <img src={jewellogo5} alt="client" />
          <img src={jewellogo6} alt="client" />
        </div>

      </div>












      {/* ENTERPRISE FEATURES SECTION */}
      {/* ENTERPRISE CAPABILITIES – SCREENSHOT STYLE */}
      {/* ENTERPRISE CAPABILITIES – WITH ICONS */}
      {/* <div className="enterprise-clean-section-jewel"> */}
      <div
        className="enterprise-clean-section-jewel"
        style={{
          backgroundImage: `url(${bgImageenterprice})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat"
        }}
      >

        <h2 className="enterprise-clean-title-jewel">
          Enterprise-Grade Capabilities for Modern Jewellers
        </h2>

        <p className="enterprise-clean-subtitle-jewel">
          IGNOSI combines accounting, analytics, security, and mobility into one
          powerful platform built exclusively for jewellery businesses.
        </p>

        <div className="enterprise-clean-content-jewel">

          {/* LEFT – SOFTWARE IMAGE */}
          <div className="enterprise-clean-image-jewel">
            <img src={laptop} alt="IGNOSI Enterprise Dashboard" />
          </div>

          {/* RIGHT – FEATURES */}
          <div className="enterprise-clean-features-jewel">

            <div className="enterprise-feature-jewel">
              <span className="enterprise-icon">💼   Financial & Accounting Integration </span>
              <div>

                <p>
                  Automated accounting across purchases, sales, stock, banking,
                  expenses, P&L reporting, and GST compliance.
                </p>
              </div>
            </div>
            <br></br>
            <div className="enterprise-feature-jewel">
              <span className="enterprise-icon">📊 Advanced Business Analytic</span>
              <div>
                <p>
                  Daily business snapshots, inventory turnover, customer lifetime
                  value, wastage tracking, and demand forecasting.
                </p>
              </div>
            </div>
            <br></br>
            <div className="enterprise-feature-jewel">
              <span className="enterprise-icon">🔐  Security & Control Features</span>
              <div>
                {/* <p>
                  Biometric authentication, CCTV-linked transactions, role-based
                  access, audit trails, and automated backups.
                </p> */}
                <p>
                  Biometric authentication, role-based
                  access, audit trails, and automated backups.
                </p>
              </div>
            </div>
            <br></br>
            <div className="enterprise-feature-jewel">
              <span className="enterprise-icon">☁️  Mobile & Cloud Capabilities</span>
              <div>
                <p>
                  Mobile stock access, remote sales apps, cloud synchronization,
                  customer apps, and WhatsApp integration.
                </p>
              </div>
            </div>
            <br></br>
            <div className="enterprise-feature-jewel">
              <span className="enterprise-icon">💎  Specialized Jewellery Modules</span>
              <div>
                <p>
                  Hallmarking management, loan against stock, showroom management,
                  loyalty programs, and repair tracking.
                </p>
              </div>
            </div>
            <br></br>
            <div className="enterprise-feature-jewel">
              <span className="enterprise-icon">📈 Comprehensive Reporting Suite</span>
              <div>
                <p>
                  Stock valuation, profit margin analysis, metal rate impact,
                  sales dashboards, and inventory health reports.
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
      {/* ENTERPRISE FEATURES SECTION END */}










      {/* ✅ POPUP MODAL */}
      {showPopup && (
        <div className="demo-popup-overlay-jewel">
          <div className="demo-popup-jewel">
            <button className="close-btn-jewel" onClick={() => setShowPopup(false)}>✕</button>
            <div className="popup-content-jewel">

              {/* <div className="popup-image-jewel">
                <img src={demojewel}
                  alt="Jewellery Software Demo"
                />
              </div> */}
              <div className="popup-image-jewel">
                {!play ? (
                  <div
                    className="video-thumbnail"
                    onClick={() => setPlay(true)}
                  >
                    <img
                      src="https://img.youtube.com/vi/5i4dbUTyOYQ/maxresdefault.jpg"
                      alt="Video Thumbnail"
                    />

                    <div className="play-button"></div>
                  </div>
                ) : (
                  <iframe
                    src="https://www.youtube.com/embed/5i4dbUTyOYQ?autoplay=1"
                    title="Jewellery Software Demo"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                )}
              </div>

              <div className="popup-form-jewel">
                <form onSubmit={(e) => handleSubmit(e, "popup")}>

                  <div className="popup-grid-jewel">

                    <input
                      type="text"
                      name="full_name"
                      placeholder="Name*"
                      value={formData.full_name}
                      onChange={handleChange}
                    />

                    <input
                      type="text"
                      name="phone"
                      placeholder="Phone No.*"
                      value={formData.phone}
                      onChange={handleChange}
                    />

                    <input
                      type="email"
                      name="email"
                      placeholder="Email ID"
                      value={formData.email}
                      onChange={handleChange}
                    />

                    <input
                      type="text"
                      name="shop_name"
                      placeholder="Jewellery Name(optional)"
                      value={formData.shop_name}
                      onChange={handleChange}
                    />

                  </div>

                  <textarea
                    name="challenges"
                    placeholder="What challenges are you looking to solve?"
                    value={formData.challenges}
                    onChange={handleChange}
                  />

                  <label className="popup-checkbox-jewel">
                    <input type="checkbox" defaultChecked />
                    I authorise Ignosi to contact me via phone, email, or WhatsApp.
                  </label>

                  <div
                    id="recaptcha-popup-jewel"
                    style={{ marginBottom: "15px" }}
                  ></div>

                  <button
                    className="popup-submit-jewel"
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Book Free Demo"}
                  </button>

                  {popupMessage && (
                    <p style={{ marginTop: "10px", fontWeight: "600" }}>
                      {popupMessage}
                    </p>
                  )}

                </form>
              </div>

            </div>
          </div>
        </div>
      )}


    </>
  );
}

export default JewelPage;
